import React from "react"
import Link from "gatsby-link"
import styled, { injectGlobal } from "styled-components"
import * as vars from "../style/vars"
import { above, below } from "../style/functions"
import { RichText, Date } from "prismic-reactjs"

const TextBlockLogos = ({ logos, header, subheader}) => {
   return (
      <Container>
         <div className="grid">
            <div className="inner">
               <div className="col col-xs-12 col-06 ">
                  <div>
                     <h2>{header}</h2>
                  </div>
                  <div>
                     <p>{subheader}</p>
                  </div>
               </div>
               <div className="col col-xs-12 col-06">
                  <LogoGrid className='clearfix'>
                  {
                     logos.map((i, idx) => (

                        <LogoGrid__ItemWrapper>
                           <LogoLink href={i.link.url} target="_blank">
                              <LogoGrid__Item className='logo-grid__item'>
                                 <LogoGrid__Content className='logo-grid__content' style={{backgroundImage:'url('+i.logo.url+')'}}>
                                 </LogoGrid__Content>
                              </LogoGrid__Item>
                           </LogoLink>
                        </LogoGrid__ItemWrapper>
                     ))
                  }
                  </LogoGrid>
               </div>
            </div>
         </div>
      </Container>
   )
}

const Container = styled.div`

padding-bottom: 7rem;

.inner:first-of-type {
   border-left: 1px solid #3f3e3e;
   padding-left: 3.5rem;
   ${below.tablet`
   padding-left: 1rem;
`}
}


  
`

const LogoGrid  = styled.div`

${above.desktop`
   border-left: 1px solid #3f3e3e;
   padding-left: 3.5rem;   
`}
`

const LogoGrid__ItemWrapper = styled.div`
width:33%;
position:relative;
float:left;

${below.desktop`
   width:25%;
`}

${below.tablet`
   width:33%;
`}

${below.mobile`
   width:50%;
`}
      
`


const LogoGrid__Item = styled.div`
width:100%;
height:0;
padding-bottom:50%;
`
const LogoLink = styled.a`
`

const LogoGrid__Content = styled.div`
position:absolute;
top:10px; 
right:10px; 
bottom:10px; 
left:10px;
background-size:contain;
background-repeat:no-repeat;
background-position: center center;

`

export default TextBlockLogos


// WEBPACK FOOTER //
// ./src/components/content_block_logos.js